<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box" style="width: 0px;">
          <div class="table-list">
            <!-- <div class="tab">
              <span style="color: #999999;">产品管理</span>
            </div> -->
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">备份与恢复列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <el-button>添加管理员</el-button> -->
                <!-- <div
                  class="btn"
                  @click="addadmin()"
                >添加</div> -->
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div>
                <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box">
              <!-- <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="startdate"
                  type="date"
                  placeholder="日期（起）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="enddate"
                  type="date"
                  placeholder="日期（止）"
                >
                </el-date-picker>
              </div> -->
              <!-- <div class="select">
                <el-input clearable v-model="flag" placeholder="请输入内容"></el-input>
              </div>
              <div class="search" @click="handleSearch()">查询</div> -->
              <div style="margin-left: auto;display: flex;">
                <div class="btn search" @click="addValueAdd()">新建备份</div>
                <div class="btn search" @click="handleSearch()">刷新</div>
              </div>
            </div>
            <div class="listsbox hqsjkdata">
              <div>
                <div class="networkListtitle">
                  <div class="useremail titlebox">文件名称</div>
                  <div class="usermobile titlebox">大小</div>
                  <div class="userfirm titlebox">备份时间</div>
                  <!-- <div class="userdate titlebox">创建时间</div> -->
                  <!-- <div class="networknum titlebox">是否启用</div> -->
                  <!-- <div class="networknum titlebox">网络数量</div>
                <div class="equipmentnum titlebox">设备数量</div> -->
                  <div class="networkoperate titlebox">
                    <div style="width: 100px; ">操作</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="userList" v-for="i in userList" :key="i.id">
                  <div class="useremail">{{ i.name }}</div>
                  <div class="usermobile">{{ i.size }}</div>
                  <div class="userfirm">{{ i.date }}</div>
                  <div class="networkoperate">
                    <!-- addValueAdd(i.name) -->
                    <div class="userkbtn" @click="handleRecovry(i.name)">恢复</div>
                    <div class="userkbtn" @click="handledownload(i.name, 'download')">下载</div>
                    <div class="userkbtn" style="color: #f5222d" @click="shownotice(i.name)">删除</div>
                  </div>

                  <!-- 删除用户 -->
                  <div v-if="i.name == delid" class="notice">
                    <div class="overlay"></div>
                    <div class="deleteallbox">
                      <div style="padding: 20px;">提示</div>
                      <div style="text-align: center;padding: 20px 30px">确认删除此备份？删除后该备份将会彻底删除！
                      </div>
                      <div style="margin-top: 16px;">
                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="shownotice(i)" class="addbtn" style="margin-left: 0px;">取消
                          </div>
                          <div @click="userDelete(i.name)" class="addbtn"
                            style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                            确定</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 确认恢复 -->
                  <custom-dialog v-if="i.name == recoveryName" width="312px" title="提示" :showCancelConfirm="false"
                    :visible.sync="recoveryVisible">
                    <div style="text-align: left;padding: 0px 0px">确认恢复此备份?</div>
                    <div style="margin-top: 36px;">
                      <div style="display: flex;justify-content: flex-end;">
                        <div @click="recoveryVisible = false" class="addbtn" style="margin-left: 0px;">取消
                        </div>
                        <div @click="handleDrawerSure" class="addbtn"
                          style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 0px;margin-bottom: 0px;">
                          确定</div>
                      </div>
                    </div>
                  </custom-dialog>
                </div>
              </div>
            </div>
          </div>
          <div style="position: absolute;width: 98%;bottom: 0px;background: #fefefe;">
            <!-- 分页 -->
            <!-- <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div> -->
            <el-pagination @size-change="handleSizeChange" style="float: right;margin-bottom: 10px;"
              @current-change="handleCurrentChange" :current-page="current" :pager-count="5"
              :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
              :total="fuserList">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增备份 -->
    <el-dialog :title="recovery ? '开始恢复' : '新增备份'" :close-on-click-modal="false" :visible.sync="dialogFormVisible"
      class="zdyxzcpzk" width="800px" :before-close="handleClose">
      <div class="add-backup">
        <div class="compressed-file flex">
          <span ref="refreshicon">
            <svg-icon :paths="$svgs.iconsdata.refresh.paths" size="20"></svg-icon>
          </span>
          <div class="file">
            <p>正在{{ recovery ? '恢复' : '备份' }}相关文件，请稍后...</p>
            <p>当前{{ recovery ? '恢复' : '备份' }}任务为后台任务，可关闭此页面进行其它操作</p>
          </div>
        </div>
        <ul class="backupmsg">
          <li>
            <p>状态：</p>
            <p>{{ backupProgress.message }}</p>
          </li>
          <li>
            <p>进度：</p>
            <p>{{ backupProgress.progress }}</p>
          </li>
          <li>
            <p>时间：</p>
            <p>{{ backupProgress.startTime }}</p>
          </li>
        </ul>
        <ul class="backupdetail">
          <li v-for="(item, index) in backuplogs" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';
import { saveAs } from 'file-saver'
export default {
  data() {
    return {
      dialogFormVisible: false,
      fuserList: null,
      userList: [],
      // dataList: [],
      currentPage: 1,
      itemsPerPage: 16,
      delid: '',//删除时的临时id
      current: 1,
      size: 10,
      deleteVisible: false,
      backupProgress: {},
      backuplogs: [],
      refresh: 0,
      timer: null,
      recovery: false,
      recoveryVisible: false,
      recoveryName: '',
      downloadName: ''
    }
  },
  created() {
    // this.$js.token();
    // //sessionStorage.setItem('tabid', '8');
    // sessionStorage.setItem('path', '/Admindata');
    // sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
  },
  methods: {
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(name) {
      // console.log(id);
      let res = await this.$apiFun.backupfilesdelete({ filename: name })
      //alert(res)
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.delid = '';
        this.selectuser();
      } else {
        this.delid = '';
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    // 展示删除框
    shownotice(item) {
      //   if (item.notice) {
      //     item.notice = !item.notice
      //   } else {
      //     this.fuserList.forEach(item => {
      //       item.notice = false
      //     })
      //     item.notice = !item.notice
      //   }
      this.delid = item;
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.size = val;
      this.selectuser();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.current = val;
      this.selectuser();
    },
    // 搜索功能
    async handleSearch() {
      this.userList = [];
      //this.fuserList = 0;
      let id = JSON.parse(sessionStorage.getItem('user')).id
      // this.userList.forEach(item => {
      //   if (item.mobile.includes(this.searchphone)) {
      //     this.fuserList.push(item);
      //   }
      // });
      let res = await this.$apiFun.backupfilesdata({ current: this.current, size: this.size });
      this.userList = res.data.records
      this.fuserList = res.data.total
    },
    //查询增值服务列表
    async selectuser() {
      // let id = JSON.parse(sessionStorage.getItem('user')).id
      let res = await this.$apiFun.backupfilesdata({ current: this.current, size: this.size });
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }
    },
    async addValueAdd(name) {
      let res = null, res1 = null
      if (name) {
        res = await this.$apiFun.addbackuprecovery({ action: 'start', filename: name });
        this.recovery = true
      } else {
        res = await this.$apiFun.addbackup({ action: 'start' });
        this.recovery = false
      }
      // console.log(res, 'ffffffffffffff');
      if (res.code == 200) {
        this.dialogFormVisible = true
        if (this.dialogFormVisible == true) {
          this.timer = setInterval(async () => {
            this.$refs.refreshicon?.classList.add('rotate')
            if (name) {
              res1 = await this.$apiFun.addbackuprecovery({ action: 'progress', taskId: res.data.taskId, filename: name });
            } else {
              res1 = await this.$apiFun.addbackup({ action: 'progress', taskId: res.data.taskId });
            }
            // console.log(res1, 'ffffffffffffff');
            // if (this.refresh == 0) {
            //   this.backuplogs = res1.data.logs
            // } else {
            //   console.log(Number(this.backupProgress.progress.split('%')[0]));
            //   if (Number(this.backupProgress.progress.split('%')[0]) < Number(res1.data.progress.split('%')[0])) {
            //     console.log(this.backupProgress.progress.split('%')[0] < res1.data.progress.split('%')[0]);
            //     this.backuplogs = [...this.backuplogs, ...res1.data.logs]
            //   }
            // }
            this.backuplogs = res1.data.logs
            this.backupProgress = res1.data
            this.refresh++
            if (this.backupProgress.status == 'completed') {
              clearInterval(this.timer)
              this.$refs.refreshicon?.classList.remove('rotate')
            }
          }, 1000)
        }
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    handleClose() {
      this.dialogFormVisible = false
      this.backupProgress = {}
      this.backuplogs = []
      clearInterval(this.timer)
    },
    async handledownload(name) {
      this.downloadName = name
      setTimeout(async () => {
        this.$message({
          message: '下载任务已创建',
          type: 'success'
        });
        let res = await this.$apiFun.addbackupdownload({ filename: name });
        this.$message({
          message: '正在下载文件，请稍后',
          type: 'success'
        });
        saveAs(new Blob([res], {
          type: 'application/octet-stream'
        }), name)
      }, 200)
    },
    handleRecovry(name) {
      this.recoveryName = name
      setTimeout(() => {
        this.recoveryVisible = true
      }, 200)
    },
    handleDrawerSure() {
      this.recoveryVisible = false
      this.addValueAdd(this.recoveryName)
    },
  }
}
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

/* .userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
} */

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.select-box {
  display: flex;
  margin-bottom: 20px;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
}

.networkListtitle {
  min-width: 1610px;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
  display: flex;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.inputcheck {
  display: flex;
}

.username {
  width: 300px;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.zdyxzcpzk:deep(.el-dialog__header) {
  padding: 20px 20px 0px;
}

.zdyxzcpzk:deep(.el-dialog__body) {
  padding: 5px 20px;
}

.zdyxzcpzk:deep(.el-dialog) {
  margin-top: 5vh !important;
}

.zdyxzcpzk:deep(.el-form-item) {
  margin-bottom: 10px;
}

.zdyxzcpzk:deep(.el-upload-list) {
  display: none;
}

.zdycpt:deep(.el-form-item__label) {
  float: unset !important;
}

.zdycpt:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 20px;
  font-size: 35px;
  color: #1677ff;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
  border: 1px dotted #cfcccc;
  text-align: center;
}

.zdybkys:deep(.el-form-item__label) {
  float: unset !important;
}

.zdybkys:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 10px 30px;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 12px;
  color: #fff;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  min-width: 1610px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  font-size: 12px;
}

.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 400px;
  flex-shrink: 0;
  display: flex;

  p {
    &:nth-child(1) {
      margin-right: 15px;
    }
  }
}

.userfirm {
  width: 600px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}

.useremail {
  width: 500px;
  flex-shrink: 0;
}

.userdate {
  width: 580px;
  flex-shrink: 0;
}

.networknum {
  width: 19.22%;
  flex-shrink: 0;
}

.equipmentnum {
  width: 9.22%;
  flex-shrink: 0;
}

.networkoperate {
  position: relative;
  width: 100px;
  display: flex;
}

.userkbtn {
  color: #1677ff;
  border: none;
  cursor: pointer;
  height: 100%;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  background-color: #fafafb;
}

:deep(.el-form) {
  .zdybkys {
    .el-form-item__label {
      position: relative;

      &:after {
        content: "*";
        display: block;
        position: absolute;
        top: -10px;
        right: 0;
        color: rgb(255, 80, 80);
      }
    }
  }
}

:deep(.zdyxzcpzk) {
  .el-dialog {
    margin-top: 15vh !important;
  }
}

.add-backup {
  display: flex;
  flex-direction: column;
  height: 550px;
  color: #333;
}

.compressed-file {
  align-items: center;
  padding: 5px 0px 20px;
  border-bottom: 1px solid #ccc;

  span {
    margin-right: 10px;
  }

  .file {
    p {
      &:nth-child(1) {
        font-size: 16px;
        margin-bottom: 6px;
      }
    }
  }
}

.backupmsg {
  display: flex;
  justify-content: space-between;
  margin: 15px 0px;

  li {
    width: 240px;

    p {
      height: 22px;
      line-height: 22px;

      &:nth-child(1) {
        font-weight: bold;
      }
    }
  }
}

.backupdetail {
  margin-bottom: 24px;
  line-height: 18px;
  background-color: #333333;
  padding: 16px;
  flex: 1;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  // max-height: 360px;
  overflow-y: auto;
}

.rotate svg {
  animation: infiniteSpin 2s linear infinite;
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}

@keyframes infiniteSpin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>